export function copyTextFunction(setState) {
  return (data) => {
    setState({
      copied: true,
      index: data,
    });
    var textField = document.createElement("textarea");
    textField.innerText = data;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };
}
